/**
 * personal folder type
 */
export type Folder = {
    /** unique folder id */
    id: string;
    /** folder name */
    name: string;
    /** parent folder id. null if it's a root folder */
    parentId: string | null;
    /** full folder path by names, from root to current */
    fullPathNames: string[];
    /** full folder path ids, from root to current */
    fullPathIds: string[];
};

export const UNFILED_FOLDER_ID = "-1";

/**
 * request params for create folder request
 */
export type CreateFolderRequestParams = {
    name: string;
    parentId: string;
};

/**
 * request params for update folder request
 */
export type UpdateFolderRequestParams = CreateFolderRequestParams & {
    id: string;
};

export type EditFolderRequestParams = CreateFolderRequestParams | UpdateFolderRequestParams;

/**
 * response params for edit folder request (create or update)
 */
export type EditFolderResponseParams = {
    success: boolean;
    message: string;
};

/**
 * request params for delete folder request
 */
export type DeleteFolderRequestParams = {
    id: string;
};

/**
 * response params for delete folder request
 */
export type DeleteFolderResponseParams = {
    success: boolean;
    message: string;
};

/**
 * request params for update media folders request
 */
export type UpdateMediaFoldersRequestParams = {
    entryIds: string[];
    addFolderIds: string[];
    removeFolderIds: string[];
};

/**
 * response params for update media folders request
 */
export type UpdateMediaFoldersResponseParams = {
    successMessages: string[];
    errorMessages: string[];
};

/**
 * request params for list media folders request
 */
export type ListMediaFoldersRequestParams = {
    entryId: string;
};

/**
 * response params for list media folders request
 */
export type ListMediaFoldersResponseParams = {
    entryFolders: string[];
};

/**
 * request params for remove media from all folders request
 */
export type RemoveMediaFromAllFoldersRequestParams = {
    entryIds: string[];
};

/**
 * response params for remove media from all folders request
 */
export type RemoveMediaFromAllFoldersResponseParams = {
    successMessages: string[];
    errorMessages: string[];
};
